module.exports = __webpack_public_path__ + "static/Sweetgreen_pin_hover-6a134c98c5f57660cd0c78d090537ded.png";